import { render, staticRenderFns } from "./TemplatePseudoTable.vue?vue&type=template&id=2b1ad270"
import script from "./TemplatePseudoTable.vue?vue&type=script&lang=js"
export * from "./TemplatePseudoTable.vue?vue&type=script&lang=js"
import style0 from "./TemplatePseudoTable.vue?vue&type=style&index=0&id=2b1ad270&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports